import { ua } from '../../../../util/user-agent';
import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(
        $rootScope,
        $state,
        $uibModal,
        AccountConfigModal,
        Alert,
        LoginRoleSelectModal,
        SamlService,
        SharedEpmFactory,

        SharedSsoFactory,
        PasswordManagers,
        $scope,
        $timeout,
        ShowNoteModal,
    ) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountConfigModal = AccountConfigModal;
        this.Alert = Alert;
        this.LoginRoleSelectModal = LoginRoleSelectModal;
        this.SamlService = SamlService;
        this.SharedEpmFactory = SharedEpmFactory;

        this.SharedSsoFactory = SharedSsoFactory;
        this.PasswordManagers = PasswordManagers;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ShowNoteModal=ShowNoteModal;
    }

    modalOpen() {
        this.$rootScope.loginModal = this.$uibModal.open({component: 'loginModal'});
    }

    $onInit() {
        this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
        this.samlAppLogo = window.env.urls.samlAppLogo;
        this.showExtensionAlert = false;

        this.showIEText = false;
        this.showExtensionAlert = false;
        this.oldExtensionInstalled =
            !!document.getElementById('extension-is-installed-v2.0.1');
        this.hasPass = false;
        this.showPassword = false;
        this.mustRenewOtp=false;
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.Alert('success', 'global.data_copied')
            })
        })
        let localStorageKey = `items-per-page:${this.$state.current.name}`;
        if (localStorage.getItem(localStorageKey) == null) {
            localStorage.setItem(localStorageKey, 500);
        }
    }

    getSamlLoginUrl(applicationId, accountId, awsrole) {
        const app = this.applications.find(a => a.applicationId === applicationId);
        const tabWindowId = window.open('about:blank', '_blank');

        tabWindowId.document.write(`
            <img
                src="${window.env.urls.samlAppLogo(app.slug)}"
                alt="${app.applicationTypeDisplayName}"
                onload="this.style.display = 'block'"
                style="display: none; margin: 50px auto 0;"
            />
        `);

        tabWindowId.document.write(`
            <p style="text-align: center; color:#40A3DB;">
                <img
                    src="${require('./orca-loader.gif')}"
                    onload="this.style.display = 'initial'"
                    alt="Loading..."
                    style="display: none; vertical-align: middle; margin-right: 5px"
                />
                Loading...
            </p>
        `);

        this.SamlService
            .getSamlLoginUrl
            .get({applicationId, accountId, awsrole})
            .$promise
            .then(data => {
                const expires = new Date(Date.now() + 60 * 1000).toUTCString();
                if (data.url.includes("&noCookie=true")) {
                    data.url = data.url.replace("&noCookie=true", '');
                } else {
                    document.cookie = `sso=${app.applicationId}; path=/; expires=${expires}`; //set on production: secure = true
                }

                if (ua.isIOS()) {
                    window.location.assign(data.url);
                } else {
                    tabWindowId.location.href = data.url;
                    if (data.url.includes("/#/")) {
                        tabWindowId.location.reload();
                    }
                }
            }, error => {
                tabWindowId.document.write(`<p style="text-align: center; color:red">Error: ${error.data}</p>`);
            });
    }

    showEditPasswordModal(application) {
        this.$uibModal
            .open({
                component: 'accountPasswordUpdate',
                resolve: {application: () => application}
            }).result
            .then(password => {
                application.password = password;
                this.Alert('success', 'applications.account_password_updated');
            });
    }

    showAccountConfigModal(applicationId, accountId) {
        this.AccountConfigModal(applicationId, accountId);
    }

    epmLogin(sharedAccount) {
        this.SharedEpmFactory.epmsSSO(sharedAccount);

        const isExtensionInstalled =
            !!document.getElementById("saaspass-extension-info") ||
            !!document.getElementById('extension-is-installed-v2.0.1') ||
            !!document.getElementById('extension-is-installed-v2.1.0');

        if (!isExtensionInstalled) {
            this.showExtensionAlert = true;
            this.showIEText = !(
                ua.isChrome() ||
                ua.isOpera() ||
                ua.isFirefox() ||
                ua.isSafari()
            );
        }
    }

    showAwsConfigModal(applicationId, accountId) {
        this.LoginRoleSelectModal(applicationId, accountId)
            .then(role => this.getSamlLoginUrl(applicationId, accountId, role));
    }


    /*
     * START - shared user account methods
     */
    isComputerAdministrationAccount(account) {
        return account.publicService.serviceName == 'ComputerLocalAccountAdministration';
    }


    copyCli(p){
        this.getPassword(p);
    }

    getPassword(p) {
        return this.PasswordManagers.getCorporatePassword(p.id).then((data)=>{
            if(data.password){
                p.password = data.password;
               // p.hiddenPass = true;
                p.hasPass = true;
            }
            else
                p.noPassword=true;
        })
    };

    getOtp(p) {
        return this.PasswordManagers.getCorporateOtp(p.id)
            .then((data)=>{p.otp = data.otp;})
            .then(()=>this.$timeout(30000))
            .then(()=>p.mustRenewOtp=true);
    };
    renewOTP(p){
        return this.PasswordManagers.getCorporateOtp(p.id)
            .then((data)=>{p.otp = data.otp;})
            .then(()=>p.mustRenewOtp=false)
            .then(()=>this.$timeout(30000))
            .then(()=>p.mustRenewOtp=true);
    }

    showPasswordF(p){
        if(p.hiddenPass== undefined || p.hiddenPass==null){
            p.hiddenPass=false;
        }
        p.hiddenPass = p.hiddenPass === false;
        if (this.isComputerAdministrationAccount(p) && p.hiddenPass == false) {
            p.password = null;
            p.hasPass = false;
        }
    }
    showNote(account){
        this.ShowNoteModal('Note', account.note);
            
    }

    ssoLogin(sharedAccount) {
        this.SharedSsoFactory.authenticatorsSSO(sharedAccount);

        const isExtensionInstalled =
            !!document.getElementById("saaspass-extension-info") ||
            !!document.getElementById('extension-is-installed-v2.0.1') ||
            !!document.getElementById('extension-is-installed-v2.1.0');

        if (!isExtensionInstalled) {
            this.showExtensionAlert = true;
            this.showIEText = !(
                ua.isChrome() ||
                ua.isOpera() ||
                ua.isFirefox() ||
                ua.isSafari()
            );
        }
    }
    /*
     * END - shared user account methods
     */
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.controller.js